module.exports = __webpack_public_path__ + "static/media/empty-state-crew.cbd8934c.svg";